export function deveExibirAssinaturaNaPagina(pageNumber, totalPages) {
  return Number(pageNumber) === Number(totalPages);
}
